<style scoped>
#button-container {
  position: absolute;
  bottom: 64px;
  left: 0;
  right: 0;
  height: 64px;
  padding: 0px 10px 8px 10px;
  box-shadow: 0px 0px 10px 11px white;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: space-evenly;
  background-color: #ffffffe0;
}

#button-container a {
  flex: 1;
  height: 100%;
  line-height: 56px;
  margin-left: 2.5px;
  margin-right: 2.5px;
}

.root {
  position: relative;
  height: 100%;
}

#detail.abs {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding-bottom: 128px;
  overflow-y: auto;
}

.input-field,
.input-field label {
  padding-left: 35px;
}

ul.order-items li {
  padding-top: 24px;
}

ul.order-items li:not(:last-child) {
  border-bottom: 1px solid #efefef;
}

@media only screen and (max-width: 600px) {
  #button-container {
    bottom: 0px;
  }

  #detail {
    padding-bottom: 64px;
  }

  #detail.abs {
    padding-top: 50px;
  }
}
.capitalzed {
  text-transform: capitalize;
}

.bold {
  font-weight: bold;
}
</style>

<template lang="pug">
.root
  #detail(:class='{ abs: isAbsolute }')
    div(v-if='isErr', :class='{ container: isAbsolute }')
      .row
        .col.s12
          p.title.large.no-margin-bottom {{ viewReferenceNumber }} is not found.
    div(v-if='!isErr && order !== null', :class='{ container: isAbsolute }')
      .row
        .col.s12
          p.title.large.no-margin-bottom {{ order.referenceNumber }}
          p.subtitle.small.no-margin-top.green-text {{ paymentMethod }}
          .vspace.medium
          p.subtitle.micro Ordered on&nbsp;
            span.black-text {{ $utils.formatter.formatLongDateTime(order.createdAt) }}
          p.subtitle.micro(v-if='processBy.displayName') Processed By&nbsp;
            span.black-text.capitalzed {{ processBy.displayName }}
            //- {{user.firstName}} {{user.lastName}} ({{user.email}})
      .vspace.large.col.s12
      .divider.col.s12
      .vspace.large.col.s12
      .row
        .col.s12
          p.subtitle.small Ordered by
          p.title.small {{ receiver }}
      .row
        .col.s12
          p.subtitle.small Deliver to
          p.title.small {{ deliveryAddress }}
      .row
        .col.s12
          p.subtitle.small Items
          ul.order-items
            li(v-for='item in sortedOrderItems')
              .row
                .col.s12.m8
                  label
                    input(
                      type='checkbox',
                      @change='onItemChange(item, $event.target.checked)',
                      :disabled='!canSelect(item)',
                      ref='itemCheckbox'
                    )
                    span.title.medium.text-uppercase.black-text {{ item.quantity }} X {{ item.productVariant.product.name }}
                      span.subtitle.micro(:class='getStatusClass(item.status)') &nbsp;&nbsp;{{ item.status }}
                      span.subtitle.micro(
                        :class='getStatusClass(item.status)',
                        v-if='item.status === STATUS_INTRANSIT && item.deliveredBy === "inomph"'
                      ) (Inom.ph)
                      p.subtitle.micro ({{ item.productVariant.variantCode }})
                      p.subtitle.micro
                        span {{ item.shop.name }}
                      p.subtitle.micro Deliver {{ getDeliverySchedule(item.deliverySchedule) }}
                      p.subtitle.micro.red-text(
                        v-if='!hasAvailableStock(item) && item.status === STATUS_NEW'
                      ) Insufficient stocks
                .col.s12.m4
                  p.right-align {{ $utils.formatter.formatAmount(item.price * item.quantity) }}
              .row
                .col.s12
              .row(v-if='item.issue === null && item.status === "in-transit"')
                .col.s12
                  p.blue-text
                    i.material-icons.left info
                    | Note: The approval for delivery is done by the Admin only
              .row(v-if='item.issue')
                .col.s12
                  p.red-text
                    i.material-icons.left warning
                    | Reason: {{ item.issue }}
                    br
                    span(v-if='(item.status === "cancelled" || item.status === "declined") && currentRouteName === "orderByReference"')
                      | Note: Cancelled or Declined orders are found in the
                      a(:href='"/order-history/"+ viewReferenceNumber', class='red-text bold') order history.
  #button-container(v-if='selectedItems.length')
    a.btn.red.darken-2.waves-effect(v-if='showDeclineOption', @click='decline') Decline
    a.btn.red.darken-2.waves-effect(v-if='showCancelOption', @click='cancel') Cancel
    a.btn.waves-effect(
      v-if='showAcceptOption',
      @click='accept',
      :class='{ disabled: !canAccept }'
    ) Accept
    a.btn.waves-effect.blue-grey.darken-1(
      v-if='showInTransitOption',
      @click='requestDelivery'
    ) Request Delivery
    //- a.btn.waves-effect(v-if='showInTransitOption', @click='inTransit') In-transit
    a.btn.waves-effect.green(
      v-if='showDeliveredOption',
      @click='delivered',
      :class='{ disabled: !canDeliver }'
    ) Delivered
</template>
<script>
import AppConfirmModalContent from './app-confirm-modal-content'
import moment from 'moment'

export default {
  props: ['order', 'isAbsolute', 'readOnly', 'isErr'],
  data () {
    return {
      modal: null,
      STATUS_NEW: 'new',
      STATUS_DECLINED: 'declined',
      STATUS_CANCELLED: 'cancelled',
      STATUS_PROCESSING: 'processing',
      STATUS_INTRANSIT: 'in-transit',
      STATUS_DELIVERED: 'delivered',
      selectedItems: [],
      viewReferenceNumber: null
    }
  },
  watch: {
    '$route.params.referenceNumber' () {
      this.resetSelection()
    }
  },
  mounted () {
    this.viewReferenceNumber = this.$route.params.referenceNumber
  },
  computed: {
    paymentMethod () {
      return this.order.paymentOption === 'cash'
        ? 'Cash'
        : this.order.paymentOption === 'bank'
          ? 'Bank Deposit' : null
    },
    showDeclineOption () {
      return this.selectedItems.every((item) => item.status === this.STATUS_NEW)
    },
    showCancelOption () {
      return this.selectedItems.every((item) =>
        [this.STATUS_INTRANSIT, this.STATUS_PROCESSING].includes(item.status)
      )
    },
    showAcceptOption () {
      return this.showDeclineOption
    },
    canAccept () {
      return this.selectedItems.every(this.hasAvailableStock)
    },
    showInTransitOption () {
      return this.selectedItems.every(
        (item) => item.status === this.STATUS_PROCESSING
      )
    },
    showDeliveredOption () {
      return this.selectedItems.every(
        (item) => item.status === this.STATUS_INTRANSIT
      )
    },
    canDeliver () {
      return this.selectedItems.every(
        (item) =>
          item.status === this.STATUS_INTRANSIT
          && item.deliveredBy === 'supplier'
      )
    },
    supplier () {
      return this.$store.state.profile.supplier
    },
    receiver () {
      return `${this.order.account.firstName} ${this.order.account.lastName} (${this.order.account.email} | ${this.contactNumber})`
    },
    deliveryAddress () {
      return this.order.orderItems[0].address
    },
    processBy () {
      // let suppliername
      // if (this.order.orderItems[0].account !== null){
      //   suppliername = this.order.orderItems[0].account.displayName
      // } else {
      //   suppliername = null
      // }
      return this.order.orderItems[0].account || {}
    },
    contactNumber () {
      return this.order.orderItems[0].contactNumber
    },
    sortedOrderItems () {
      let copy = this.order.orderItems.slice()
      return copy.sort(this.sortCompareItem)
    },
    user () {
      return this.$store.state.auth.user || {}
    },
    currentRouteName () {
      return this.$route.name
    }
  },
  methods: {
    setOrderItemShop (item, shopId) {
      this.selectedItems.some((selectedItem, index) => {
        if (item.id === selectedItem.id) {
          selectedItem.productVariant.inventories.some((inventory) => {
            if (parseInt(inventory.id) === parseInt(shopId)) {
              selectedItem.fromInventory = inventory
              this.selectedItems.splice(index, 1, selectedItem)
              return true
            }
          })
          return true
        }
      })
    },
    sortCompareItem (itemA, itemB) {
      if (itemA.status === itemB.status) {
        return 0
      }

      if (
        [this.STATUS_DECLINED, this.STATUS_CANCELLED].includes(itemA.status)
        || itemB.status === this.STATUS_NEW
      ) {
        return 1
      }

      if (
        itemA.status === this.STATUS_NEW
        || (itemA.status === this.STATUS_PROCESSING
          && (itemB.status === this.STATUS_INTRANSIT
            || itemB.status === this.STATUS_DELIVERED))
        || (itemA.status === this.STATUS_INTRANSIT
          && itemB.status === this.STATUS_DELIVERED)
        || [this.STATUS_DECLINED, this.STATUS_CANCELLED].includes(itemB.status)
      ) {
        return -1
      }

      return 1
    },
    hasAvailableStock (item) {
      return item.productVariant.availableStock >= item.quantity
    },
    getAvailableInventories (item) {
      let inventories = []
      let defaultInventory
      if (item.productVariant.inventories !== undefined) {
        item.productVariant.inventories.forEach((inventory) => {
          if (inventory.availableStock >= item.quantity) {
            defaultInventory = inventory
          } else {
            inventories.push(inventory)
          }
        })
      }

      if (defaultInventory) {
        inventories.splice(0, 0, defaultInventory)
      }
    },
    canSelect (item) {
      return (
        !this.readOnly
        && ![
          this.STATUS_DECLINED,
          this.STATUS_DELIVERED,
          this.STATUS_CANCELLED
        ].includes(item.status)
      )
    },
    resetSelection () {
      this.viewReferenceNumber = this.$route.params.referenceNumber
      this.selectedItems = []
      this.$refs.itemCheckbox.forEach((checkbox) => {
        checkbox.checked = false
      })
    },
    getDeliverySchedule (value) {
      if (value === 'same_day') {
        return 'By Today'
      } else if (value.startsWith('range')) {
        return (
          'By ' + value.split(':')[1].replace(';', ' to ') + ' business days'
        )
      } else if (value.startsWith('scheduled')) {
        return 'On ' + value.split(':')[1]
      }
    },
    onItemChange (item, isSelected) {
      if (isSelected) {
        this.selectedItems.push(item)

        // if (item.status === this.STATUS_NEW) {
        //   this.$nextTick(() => {
        //     let select = this.$M.FormSelect.init(
        //       document.getElementById('select-' + item.id)
        //     )
        //     this.setOrderItemShop(item, select.el.value)
        //   })
        // }
      } else {
        this.selectedItems = this.selectedItems.filter(
          (curItem) => curItem.id !== item.id
        )
      }
    },
    getStatusClass (status) {
      return {
        'indigo-text': status === this.STATUS_NEW,
        'green-text': status === this.STATUS_DELIVERED,
        'red-text':
          status === this.STATUS_DECLINED || status === this.STATUS_CANCELLED,
        'blue-text': status === this.STATUS_INTRANSIT,
        'orange-text': status === this.STATUS_PROCESSING
      }
    },
    updateStatus (items, status, issue, requestDelivery) {
      this.resetSelection()
      return this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        const updates = items.map((item) => {
          return this.$http.post(
            `${this.$config.API_URL}/suppliers/${this.supplier.id}/orders/${this.order.id}/order-item/${item.id}/status`,
            {
              status: status,
              issue: issue,
              deliveredBy: requestDelivery ? 'Inomph' : 'Supplier',
              processBy: this.user.id
            },
            {
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            }
          )
        })

        if (updates) {
          let orderItems = []
          let orderStatus
          switch (status) {
            case 'new':
              orderStatus = 'open'
              break
            case 'processing':
              orderStatus = 'open'
              break
            case 'in-transit':
              orderStatus = 'open'
              break
            case 'cancelled':
              orderStatus = 'canceled'
              break
            case 'declined':
              orderStatus = 'canceled'
              break
            case 'delivered':
              orderStatus = 'closed'
              break

            default:
              break
          }

          items.forEach(item => {
            orderItems.push({
              'itemcode': item.productVariant.product.productCode,
              'itemqty': `${item.quantity}`,
              'itemprice': item.price,
              'itemPriceAfterVAT': '0'
            })
          })

          if (!this.order.sapInternalID) {
            this.$http.post(`${this.$config.API_URL}/customers/${this.order.account.uid}/orders/salesorder`, {
              'orderId': this.order.id,
              'customerID': this.order.account.id,
              'docdate': new Date(moment().locale('en').format('YYYY-MM-DD')),
              'orderNumber': this.order.referenceNumber,
              'docduedate': new Date(moment().locale('en').add(3, 'd').format('YYYY-MM-DD')),
              'orderStatus': orderStatus,
              'products': orderItems,
              'billtoaddressID': '',
              'shiptoaddressID': '',
              'comments': 'This is a Sales Order'
            }, {
              headers: {
                authorization: `Bearer ${accessToken}`
              }
            }).catch(err => {
              this.$snackbar.error('Failed to connect, please try again.', err.message)
            })
          } else {
            this.$http.put(`${this.$config.API_URL}/customers/${this.order.account.uid}/orders/updateorderstatus`, {
              'internalid': `${this.order.sapInternalID}`,
              'orderstatus': orderStatus
            }, {
              headers: {
                authorization: `Bearer ${accessToken}`
              }
            }).catch(err => {
              this.$snackbar.error('Failed to connect, please try again.', err.message)
            })
          }
        }

        return Promise.all(updates)
      })
    },
    accept () {
      return this.updateStatus(this.selectedItems, this.STATUS_PROCESSING).then(
        () => {
          this.$snackbar.success('Items accepted')
          this.$emit('orderUpdated', this.order)
        }
      )
    },
    inTransit () {
      return this.updateStatus(
        this.selectedItems,
        this.STATUS_INTRANSIT,
        null,
        false
      ).then(() => {
        this.$snackbar.success('Items updated')
        this.$emit('orderUpdated', this.order)
      })
    },
    requestDelivery () {
      return this.updateStatus(
        this.selectedItems,
        this.STATUS_INTRANSIT,
        null,
        true
      ).then(() => {
        this.$snackbar.success('Items updated')
        this.$emit('orderUpdated', this.order)
      })
    },
    delivered () {
      return this.updateStatus(this.selectedItems, this.STATUS_DELIVERED).then(
        () => {
          this.$snackbar.success('Items delivered')
          this.$emit('orderUpdated', this.order)
        }
      )
    },
    decline () {
      const modalParams = {
        content: AppConfirmModalContent,
        style: { padding: 'medium' },
        bind: {
          action: 'Decline',
          onConfirm: this.confirmDecline,
          onCancel: this.cancelDecline,
          orderReferenceNumber:
            this.order !== null ? this.order.referenceNumber : null
        }
      }
      this.$store.dispatch('modal/open', modalParams).then((modal) => {
        this.modal = modal
      })
    },
    cancel () {
      const modalParams = {
        content: AppConfirmModalContent,
        style: { padding: 'medium' },
        bind: {
          action: 'Cancel',
          onConfirm: this.confirmCancel,
          onCancel: this.cancelDecline,
          orderReferenceNumber:
            this.order !== null ? this.order.referenceNumber : null
        }
      }
      this.$store.dispatch('modal/open', modalParams).then((modal) => {
        this.modal = modal
      })
    },
    confirmCancel (reasonForCancel) {
      return this.updateStatus(
        this.selectedItems,
        this.STATUS_CANCELLED,
        reasonForCancel
      ).then(() => {
        this.modal.close()
        this.$snackbar.success('Item cancelled')
        this.$emit('orderUpdated', this.order)
      })
    },
    confirmDecline (reasonForDecline) {
      return this.updateStatus(
        this.selectedItems,
        this.STATUS_DECLINED,
        reasonForDecline
      ).then(() => {
        this.modal.close()
        this.$snackbar.success('Item declined')
        this.$emit('orderUpdated', this.order)
      })
    },
    cancelDecline () {
      this.modal.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-order-details.vue